module.exports = __webpack_public_path__ + "static/media/svg-intro.4fd25aae.svg";